export default __webpack_public_path__ + "static/media/gallery_01.cc61f32e.jpg";